<template>
  <svg
    role="img"
    aria-label="trash icon"
    class="trash-icon o-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
  >
    <title>Trash</title>
    <path
      d="M19.08,25.2h-10.21c-.84,0-1.64-.29-2.25-.82-.63-.55-.98-1.31-.98-2.1v-9.83c0-.41.34-.75.75-.75s.75.34.75.75v9.83c0,.36.17.71.47.97.33.29.79.45,1.26.45h10.21c.47,0,.93-.16,1.26-.45.3-.27.47-.61.47-.97v-9.83c0-.41.34-.75.75-.75s.75.34.75.75v9.83c0,.79-.36,1.55-.98,2.1-.61.53-1.41.82-2.25.82Z"
      fill="currentColor"
    />
    <path
      d="M13.97,21.51c-.41,0-.75-.34-.75-.75v-7.08c0-.41.34-.75.75-.75s.75.34.75.75v7.08c0,.41-.34.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M17.78,21.51c-.41,0-.75-.34-.75-.75v-7.08c0-.41.34-.75.75-.75s.75.34.75.75v7.08c0,.41-.34.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M10.23,21.51c-.41,0-.75-.34-.75-.75v-7.08c0-.41.34-.75.75-.75s.75.34.75.75v7.08c0,.41-.34.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M21.72,6.16h-4.39,0c0-1.85-1.51-3.36-3.36-3.36s-3.36,1.51-3.36,3.36h0s-4.39,0-4.39,0c-1.24,0-2.25,1.01-2.25,2.25s1.01,2.25,2.25,2.25h15.5c1.24,0,2.25-1.01,2.25-2.25s-1.01-2.25-2.25-2.25ZM12.11,6.16c0-1.03.83-1.86,1.86-1.86s1.86.83,1.86,1.86h0s-3.72,0-3.72,0h0ZM21.72,9.16H6.22c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h15.5c.41,0,.75.34.75.75s-.34.75-.75.75Z"
      fill="currentColor"
    />
  </svg>
</template>

<style lang="scss" scoped>
.trash-icon {
  height: 28px;
  width: 28px;
}
</style>
